import { resetCompanyScan } from '../store/redux/slices/companyScanSlice';
import store from '../store/redux/store';

interface ResetState {
  reset: () => void;
}

const useCompanyScanResetState = (): ResetState => {
  const reset = () => {
    store.dispatch(resetCompanyScan());
  };

  return { reset };
};

export default useCompanyScanResetState;
